export const Storage = {
  API_KEY: 'api_key',
  TOKEN: 'token',
  LANGUAGE: 'language',
}

export const csvFileType = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  '.csv',
]

export const TYPES_IMAGE_ALLOWED = [
  'image/png',
  'image/jpeg',
  // 'image/jpg',
]

export const LENGTH_BIT_IMAGE = 10 * 1024 * 1024 //10MB
export const TOKEN_INFO_USER_INDEX = 1
export const TENANT_INFO_INDEX = 1

export const CSV_KEY_REQUIREMENT = [
  'TenantCd',
  'ProductCd',
  'ProductName',
  'ProductDescribe',
  'ProductImg',
  'InspectionImg',
  'ManufacturingImg',
  'Feature',
  'Merit',
  'Weight',
  'WeightUnit',
  'Size',
  'LastUpdated',
  'Language',
]

export const CSV_KEY_WITH_PREFIX = 'Property_'

export const PRIVATE_DATA_LANGUAGE = {
  ENGLISH: 'English',
  JAPANESE: 'Japanese',
}
